import type {
  InputMaybe,
  InsurerUsersOrderBy,
} from "@alaffia-technology-solutions/client-sdk";

import { createMutationHook, createQueryHook } from "../factory";

const auditorUserKeys = {
  all: ["auditorUsers"] as const,
  lists: () => [...auditorUserKeys.all, "list"] as const,
  list: <T>(filters: T) => [...auditorUserKeys.lists(), filters] as const,
  details: () => [...auditorUserKeys.all, "detail"] as const,
  detail: ({
    id,
    insurerUsersOrderBy,
  }: {
    id: string;
    insurerUsersOrderBy: InputMaybe<
      InsurerUsersOrderBy | InsurerUsersOrderBy[]
    >;
  }) => [...auditorUserKeys.details(), id, insurerUsersOrderBy] as const,
};

export const auditorUsers = {
  editAuditorUser: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.auditorUsers.editAuditorUser,
    mutationKey: ["auditorUsers", "editAuditorUser"],
  }),
  getAuditorUser: createQueryHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.auditorUsers.getAuditorUser,
    queryKeyFn: auditorUserKeys.detail,
  }),
  getAuditorUsers: createQueryHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.auditorUsers.getAuditorUsers,
    queryKeyFn: auditorUserKeys.list,
  }),
};
